const async_hook = {};
export default async_hook